import { render, staticRenderFns } from "./MaterialPickModal.vue?vue&type=template&id=668a3890&scoped=true"
import script from "./MaterialPickModal.vue?vue&type=script&lang=js"
export * from "./MaterialPickModal.vue?vue&type=script&lang=js"
import style0 from "./MaterialPickModal.vue?vue&type=style&index=0&id=668a3890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668a3890",
  null
  
)

export default component.exports